import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["arrow", "autofill", "autoFocus", "CardLogo", "disabled", "error", "errorLabel", "fieldLink", "fieldLinkAriaLabel", "fieldLinkDisabled", "fieldLinkRole", "fieldTooltip", "fieldTooltipDoNotFold", "fieldTooltipFluidWidth", "fieldTooltipAriaLabel", "focused", "hasDegradedPerformance", "hasValue", "icon", "tooltipActive", "iconTooltip", "label", "loading", "mouseflowExclude", "name", "onDisabledClick", "onFieldLinkClick", "onFieldTooltipClick", "obfuscatedValue", "value", "warning", "warningLabel", "darkBackground", "hasLabel", "hovered", "position", "squareBottomBorder", "stack", "type", "width", "cardNumberField", "ids", "isUnderlined", "id", "onAutofill", "onEndAutofill", "pressed", "isObfuscated", "UNSAFE_inputProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import IconInformationError from '@bubble-ui/icon-information-error';
import IconWarning from '@bubble-ui/icon-warning';
import View from '@bubble-ui/primitive-view';
import FieldTooltipParticle from '@bubble-ui/temp-field-tooltip';
import baseField from '@bubble-ui/temp-base-field'; // @ts-expect-error

import LabelParticle from '@bubble-ui/atom-label';
import InputParticle from '@bubble-ui/temp-input';
import TextInput from '@bubble-ui/primitive-text-input'; // @ts-expect-error

import FieldLinkParticle from '@bubble-ui/temp-field-link';
import { isNative, platformSelect } from '@bubble-ui/util-platform'; // @ts-expect-error

import { Motion, spring } from '@bubble-ui/primitive-motion';
import Loader from '@bubble-ui/molecule-loader'; // @ts-expect-error

import LinkDetail from '@bubble-ui/molecule-link-detail';
import SpacerHorizontal from '@bubble-ui/atom-spacer-horizontal';
import SpacerVertical from '@bubble-ui/atom-spacer-vertical';
import Text from '@bubble-ui/primitive-text';
import { useDesignContext, Color } from '@klarna/designtokens';
import usePreventDefaultHandlers from '@bubble-ui/hook-use-prevent-default-handlers';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import useUncontrolledProp from '@bubble-ui/hook-use-uncontrolled-prop';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useTokenDeprecationWarning from '@bubble-ui/hook-use-token-deprecation-warning';
import defaultDesignTokens from './defaultDesignTokens';
import getDefaultStyleSheet from './getDefaultStyleSheet';

var Field = function Field(_ref) {
  var arrow = _ref.arrow,
      autofill = _ref.autofill,
      autoFocus = _ref.autoFocus,
      CardLogo = _ref.CardLogo,
      disabled = _ref.disabled,
      error = _ref.error,
      errorLabel = _ref.errorLabel,
      fieldLink = _ref.fieldLink,
      fieldLinkAriaLabel = _ref.fieldLinkAriaLabel,
      fieldLinkDisabled = _ref.fieldLinkDisabled,
      fieldLinkRole = _ref.fieldLinkRole,
      fieldTooltip = _ref.fieldTooltip,
      fieldTooltipDoNotFold = _ref.fieldTooltipDoNotFold,
      fieldTooltipFluidWidth = _ref.fieldTooltipFluidWidth,
      fieldTooltipAriaLabel = _ref.fieldTooltipAriaLabel,
      focused = _ref.focused,
      hasDegradedPerformance = _ref.hasDegradedPerformance,
      hasValue = _ref.hasValue,
      icon = _ref.icon,
      tooltipActive = _ref.tooltipActive,
      iconTooltip = _ref.iconTooltip,
      label = _ref.label,
      loading = _ref.loading,
      mouseflowExclude = _ref.mouseflowExclude,
      name = _ref.name,
      onDisabledClick = _ref.onDisabledClick,
      onFieldLinkClick = _ref.onFieldLinkClick,
      onFieldTooltipClick = _ref.onFieldTooltipClick,
      obfuscatedValue = _ref.obfuscatedValue,
      value = _ref.value,
      warning = _ref.warning,
      warningLabel = _ref.warningLabel,
      darkBackground = _ref.darkBackground,
      hasLabel = _ref.hasLabel,
      hovered = _ref.hovered,
      position = _ref.position,
      squareBottomBorder = _ref.squareBottomBorder,
      stack = _ref.stack,
      type = _ref.type,
      width = _ref.width,
      cardNumberField = _ref.cardNumberField,
      ids = _ref.ids,
      isUnderlined = _ref.isUnderlined,
      id = _ref.id,
      onAutofill = _ref.onAutofill,
      onEndAutofill = _ref.onEndAutofill,
      pressed = _ref.pressed,
      isObfuscated = _ref.isObfuscated,
      UNSAFE_inputProps = _ref.UNSAFE_inputProps,
      props = _objectWithoutProperties(_ref, _excluded);

  usePropDeprecationWarning({
    componentName: 'Field',
    propName: 'errorLabel',
    shouldWarn: errorLabel !== undefined,
    removalDate: 'v5.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Field',
    propName: 'warningLabel',
    shouldWarn: warningLabel !== undefined,
    removalDate: 'v5.0.0'
  });

  var _useUncontrolledProp = useUncontrolledProp({
    prop: tooltipActive
  }),
      _useUncontrolledProp2 = _slicedToArray(_useUncontrolledProp, 2),
      isTooltipActive = _useUncontrolledProp2[0],
      onActive = _useUncontrolledProp2[1];

  var _usePreventDefaultHan = usePreventDefaultHandlers([onFieldLinkClick, onFieldTooltipClick]),
      _usePreventDefaultHan2 = _slicedToArray(_usePreventDefaultHan, 2),
      onFieldLinkClickPreventDefault = _usePreventDefaultHan2[0],
      onFieldTooltipClickPreventDefault = _usePreventDefaultHan2[1];

  var designVersion = useDesignVersion();
  var designContext = useDesignContext(defaultDesignTokens);
  var deprecatedFieldBackgroundColorTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/background-color');
  var deprecatedFieldBorderColorTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/border-color');
  var deprecatedFieldInputTextColorTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/input-text-color');
  var deprecatedFieldLabelTextColorTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/label-text-color');
  var deprecatedFieldInputTextStyleTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/input-text-style');
  var deprecatedFieldLabelTextStyleTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/label-text-style');
  useTokenDeprecationWarning({
    componentName: 'Field',
    tokenName: 'inputs/fields-boxed/background-color',
    useInstead: 'field/background-color',
    shouldWarn: deprecatedFieldBackgroundColorTokenExists,
    removalDate: 'v5.0.0'
  });
  useTokenDeprecationWarning({
    componentName: 'Field',
    tokenName: 'inputs/fields-boxed/border-color',
    useInstead: 'field/border-color',
    shouldWarn: deprecatedFieldBorderColorTokenExists,
    removalDate: 'v5.0.0'
  });
  useTokenDeprecationWarning({
    componentName: 'Field',
    tokenName: 'inputs/fields-boxed/input-text-color',
    useInstead: 'field/input-text-color',
    shouldWarn: deprecatedFieldInputTextColorTokenExists,
    removalDate: 'v5.0.0'
  });
  useTokenDeprecationWarning({
    componentName: 'Field',
    tokenName: 'inputs/fields-boxed/label-text-color',
    useInstead: 'field/label-text-color',
    shouldWarn: deprecatedFieldLabelTextColorTokenExists,
    removalDate: 'v5.0.0'
  });
  useTokenDeprecationWarning({
    componentName: 'Field',
    tokenName: 'inputs/fields-boxed/input-text-style',
    useInstead: 'field/input-text-style',
    shouldWarn: deprecatedFieldInputTextStyleTokenExists,
    removalDate: 'v5.0.0'
  });
  useTokenDeprecationWarning({
    componentName: 'Field',
    tokenName: 'inputs/fields-boxed/label-text-style',
    useInstead: 'field/label-text-style',
    shouldWarn: deprecatedFieldLabelTextStyleTokenExists,
    removalDate: 'v5.0.0'
  });
  Field.displayName = 'Field';

  var _useStyleSheet = useStyleSheet(Field, getDefaultStyleSheet, _objectSpread({
    autofill: autofill,
    autoFocus: autoFocus,
    darkBackground: darkBackground,
    disabled: disabled,
    error: error,
    errorLabel: errorLabel,
    fieldTooltip: fieldTooltip,
    focused: focused,
    hasLabel: hasLabel,
    hasValue: hasValue,
    hovered: hovered,
    icon: icon,
    obfuscatedValue: obfuscatedValue,
    position: position,
    squareBottomBorder: squareBottomBorder,
    stack: stack,
    tooltipActive: isTooltipActive,
    warning: warning,
    warningLabel: warningLabel,
    width: width,
    cardNumberField: cardNumberField,
    designContext: designContext,
    designVersion: designVersion,
    isUnderlined: isUnderlined
  }, props)),
      rootStyle = _useStyleSheet.rootStyle,
      cardLogoStyle = _useStyleSheet.cardLogoStyle,
      containerStyle = _useStyleSheet.containerStyle,
      errorLabelWrapperStyle = _useStyleSheet.errorLabelWrapperStyle,
      errorLabelTextWrapperStyle = _useStyleSheet.errorLabelTextWrapperStyle,
      iconColorStyle = _useStyleSheet.iconColorStyle,
      cardWrapperStyle = _useStyleSheet.cardWrapperStyle,
      iconStyle = _useStyleSheet.iconStyle,
      inputStyle = _useStyleSheet.inputStyle,
      labelViewStyle = _useStyleSheet.labelViewStyle,
      labelTextStyle = _useStyleSheet.labelTextStyle,
      loaderStyle = _useStyleSheet.loaderStyle,
      obfuscatedValueWrapperStyle = _useStyleSheet.obfuscatedValueWrapperStyle,
      obfuscatedValueStyle = _useStyleSheet.obfuscatedValueStyle,
      textWrapperStyle = _useStyleSheet.textWrapperStyle,
      linkWrapperStyle = _useStyleSheet.linkWrapperStyle,
      labelFeedbackStateIconStyle = _useStyleSheet.labelFeedbackStateIconStyle,
      labelFeedbackStateColor = _useStyleSheet.labelFeedbackStateColor,
      warningLabelWrapperStyle = _useStyleSheet.warningLabelWrapperStyle,
      warningLabelTextWrapperStyle = _useStyleSheet.warningLabelTextWrapperStyle,
      paragraphSecondaryCorrectFootprintStyle = _useStyleSheet.paragraphSecondaryCorrectFootprintStyle,
      paragraphSecondaryCorrectFootprintErrorStyle = _useStyleSheet.paragraphSecondaryCorrectFootprintErrorStyle,
      paragraphSecondaryCorrectFootprintWarningStyle = _useStyleSheet.paragraphSecondaryCorrectFootprintWarningStyle;

  var targetBorderColor = new Color(containerStyle.borderColor).toArray();
  var targetBackgroundColor = new Color(containerStyle.backgroundColor).toArray();
  return /*#__PURE__*/React.createElement(Motion, {
    style: {
      backgroundColorR: spring(targetBackgroundColor[0]),
      backgroundColorG: spring(targetBackgroundColor[1]),
      backgroundColorB: spring(targetBackgroundColor[2]),
      backgroundColorA: spring(targetBackgroundColor[3]),
      borderColorR: spring(targetBorderColor[0]),
      borderColorG: spring(targetBorderColor[1]),
      borderColorB: spring(targetBorderColor[2])
    }
  }, function (_ref2) {
    var backgroundColorR = _ref2.backgroundColorR,
        backgroundColorG = _ref2.backgroundColorG,
        backgroundColorB = _ref2.backgroundColorB,
        backgroundColorA = _ref2.backgroundColorA,
        borderColorR = _ref2.borderColorR,
        borderColorG = _ref2.borderColorG,
        borderColorB = _ref2.borderColorB;
    return /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.root,
      style: rootStyle
    }, /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.container,
      tag: "label",
      accessibilityTraits: disabled ? ['disabled'] : undefined,
      accessibilityState: {
        disabled: disabled
      },
      htmlFor: (ids === null || ids === void 0 ? void 0 : ids.input) || name,
      onClick: function onClick(e) {
        return disabled && onDisabledClick && onDisabledClick(e);
      },
      style: _objectSpread(_objectSpread({}, containerStyle), {}, {
        backgroundColor: "rgba(".concat(Math.round(backgroundColorR), ", ").concat(Math.round(backgroundColorG), ", ").concat(Math.round(backgroundColorB), ", ").concat(backgroundColorA, ")"),
        borderColor: "rgb(".concat(Math.round(borderColorR), ", ").concat(Math.round(borderColorG), ", ").concat(Math.round(borderColorB), ")")
      })
    }, (icon || CardLogo) && /*#__PURE__*/React.createElement(View, {
      style: cardWrapperStyle
    }, CardLogo && /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.cardLogo,
      style: cardLogoStyle
    }, /*#__PURE__*/React.createElement(CardLogo, null)), icon && !CardLogo && /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.icon,
      style: iconStyle
    }, /*#__PURE__*/React.cloneElement(icon, iconColorStyle))), /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.textWrapper,
      style: textWrapperStyle
    }, label && label !== '' && /*#__PURE__*/React.createElement(LabelParticle, {
      labelFeedbackStateIconStyle: labelFeedbackStateIconStyle,
      labelFeedbackStateColor: labelFeedbackStateColor([backgroundColorR, backgroundColorG, backgroundColorB, backgroundColorA]).color,
      error: error,
      warning: warning,
      hasValue: hasValue || obfuscatedValue && obfuscatedValue !== '' || hasDegradedPerformance || !isNative && type === 'date',
      focused: focused || error || warning || autofill || errorLabel !== undefined || warningLabel !== undefined,
      id: ids === null || ids === void 0 ? void 0 : ids.label,
      viewStyle: labelViewStyle,
      textStyle: labelTextStyle
    }, label), props.Input !== undefined ? /*#__PURE__*/React.createElement(InputParticle, _extends({}, UNSAFE_inputProps, platformSelect({
      ios: {
        selectionColor: inputStyle.caretColor
      },
      android: {},
      web: {}
    }), {
      accessibilityLabel: label,
      autoFocus: autoFocus,
      disabled: disabled,
      id: (ids === null || ids === void 0 ? void 0 : ids.input) || name,
      name: name,
      style: inputStyle,
      type: type,
      value: obfuscatedValue && obfuscatedValue !== '' ? obfuscatedValue : value,
      mouseflowExclude: mouseflowExclude
    }, props)) : /*#__PURE__*/React.createElement(TextInput, _extends({}, UNSAFE_inputProps, platformSelect({
      ios: {
        selectionColor: inputStyle.caretColor
      },
      android: {},
      web: {}
    }), {
      accessibilityLabel: label,
      autoFocus: autoFocus,
      disabled: disabled,
      id: (ids === null || ids === void 0 ? void 0 : ids.input) || name,
      name: name,
      style: inputStyle,
      type: type,
      value: obfuscatedValue && obfuscatedValue !== '' ? obfuscatedValue : value
    }, props)), obfuscatedValue && obfuscatedValue !== '' && /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.obfuscatedValue,
      style: obfuscatedValueWrapperStyle
    }, /*#__PURE__*/React.createElement(Text, {
      numberOfLines: 0,
      tag: "paragraph",
      style: obfuscatedValueStyle
    }, obfuscatedValue))), loading && /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.loader,
      style: loaderStyle
    }, /*#__PURE__*/React.createElement(Loader, null)), fieldLink && !hasDegradedPerformance && /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.fieldLinkWrapper,
      style: linkWrapperStyle
    }, /*#__PURE__*/React.createElement(FieldLinkParticle, {
      disabled: fieldLinkDisabled,
      ariaLabel: fieldLinkAriaLabel,
      role: fieldLinkRole,
      overTintedBackground: (error || warning) && !focused || autofill || disabled && !fieldLinkDisabled,
      id: ids === null || ids === void 0 ? void 0 : ids.fieldLink,
      onClick: onFieldLinkClickPreventDefault
    }, fieldLink))), fieldTooltip && /*#__PURE__*/React.createElement(FieldTooltipParticle, {
      icon: iconTooltip,
      id: ids === null || ids === void 0 ? void 0 : ids.fieldTooltip,
      disabled: disabled,
      arrow: arrow,
      autofill: autofill,
      error: error,
      fieldTooltipDoNotFold: fieldTooltipDoNotFold,
      hasFluidWidth: fieldTooltipFluidWidth,
      fieldTooltip: fieldTooltip,
      onActive: onActive,
      onClick: onFieldTooltipClickPreventDefault,
      warning: warning,
      ariaLabel: fieldTooltipAriaLabel,
      withPadding: !isUnderlined
    }), fieldLink && hasDegradedPerformance && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(SpacerVertical, {
      spaceToken: "space.100"
    }), /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
      numberOfLines: 0
    } : {}, {
      tag: "paragraph",
      style: paragraphSecondaryCorrectFootprintStyle
    }), /*#__PURE__*/React.createElement(LinkDetail, {
      inParagraph: true,
      disabled: fieldLinkDisabled,
      id: ids === null || ids === void 0 ? void 0 : ids.fieldLink,
      onPress: onFieldLinkClickPreventDefault,
      ariaLabel: fieldLinkAriaLabel,
      role: fieldLinkRole
    }, fieldLink))), errorLabel !== undefined && /*#__PURE__*/React.createElement(View, {
      style: errorLabelWrapperStyle
    }, /*#__PURE__*/React.createElement(SpacerHorizontal, {
      medium: true
    }), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(IconInformationError, {
      colorToken: "colors/text/error"
    })), /*#__PURE__*/React.createElement(SpacerHorizontal, {
      small: true
    }), /*#__PURE__*/React.createElement(View, {
      style: errorLabelTextWrapperStyle
    }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
      numberOfLines: 0
    } : {}, {
      tag: "paragraph",
      style: paragraphSecondaryCorrectFootprintErrorStyle
    }), errorLabel))), warningLabel !== undefined && /*#__PURE__*/React.createElement(View, {
      style: warningLabelWrapperStyle
    }, /*#__PURE__*/React.createElement(SpacerHorizontal, {
      medium: true
    }), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(IconWarning, {
      colorToken: "colors/text/warning"
    })), /*#__PURE__*/React.createElement(SpacerHorizontal, {
      small: true
    }), /*#__PURE__*/React.createElement(View, {
      style: warningLabelTextWrapperStyle
    }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
      numberOfLines: 0
    } : {}, {
      tag: "paragraph",
      style: paragraphSecondaryCorrectFootprintWarningStyle
    }), warningLabel))));
  });
};

var FieldRegular = baseField(Field);
FieldRegular.displayName = 'Field';
export default withProvisionalOverrideFromContext(FieldRegular);
//# sourceMappingURL=index.js.map